import React, { ComponentPropsWithoutRef, useEffect, useRef } from "react";
import classes from "./Rocket.module.scss";
import classNames from "classnames";
import useWindowDimensions from "../../hooks/useWindowDimension";
import RocketSVG from "../../../public/icons/rocket-flying.svg";

interface Props extends ComponentPropsWithoutRef<'div'> { }

function Rocket({ className, ...htmlProps }: Props) {
  let rocketObserver: IntersectionObserver;
  const rocketRef = useRef<HTMLDivElement | null>(null);

  const { width } = useWindowDimensions();
  const smallOrLower: boolean = width < 768;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    rocketObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              if (smallOrLower) {
                entry.target.classList.add(
                  classes.rocket__animationRocketFlyingMobile
                );
              } else {
                entry.target.classList.add(
                  classes.rocket__animationRocketFlyingDesktop
                );
              }
            }, 2000);
          }
        });
      },
      {
        threshold: 0.65,
      }
    );

    if (rocketRef.current) {
      rocketObserver.observe(rocketRef.current);
    }

    return () => {
      rocketObserver.disconnect();
    };
  }, [rocketRef]);

  return (
    <div {...htmlProps} className={classNames(classes.rocket)}>
      <div className={classes.rocket__container} ref={rocketRef}>
        <RocketSVG className={classes.rocket__icon} />
      </div>
    </div>
  );
}

export default Rocket;
